import { ResourceModel } from './../product-category/models/resource.model';
import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild, ChangeDetectorRef, HostListener } from '@angular/core';
import { Http, Response } from '@angular/http';
import { FormBuilder, FormGroup, Validator, Validators } from '@angular/forms';
import { Observable } from 'rxjs/Observable';
import * as force from '../force';
import * as moment from "moment";
import { ProductCategoryService } from "../product-category/services/product-category.service";
import { MatDialog } from "@angular/material";
import {
  DxDataGridComponent,
  DxDataGridModule,
  DxSelectBoxModule,
  DxCheckBoxModule
} from "devextreme-angular";
import { ImageUser } from "../image-admin/image-models/image-user.model";
import { ResourceMappingModel } from "./models/resource-mapping.model";
import notify from "devextreme/ui/notify";
import {MomentDateAdapter} from "./../date-adapter/moment-date-adapter.class"



@Component({
  selector: 'app-resource-mapping',
  templateUrl: './resource-mapping.component.html',
  styleUrls: ['./resource-mapping.component.css']
})
export class ResourceMappingComponent implements OnInit  {
 isUserAuthenticated: boolean = false;
 isCorrectRole: boolean = false;
 showRowAssignActions: boolean = false;
 showRowUnassignActions: boolean = false;
 identifier: string;
 momentdateadapter: MomentDateAdapter = new MomentDateAdapter();
 form: FormGroup;
 selectedAssignRows = [];
 selectedUnassignRows = [];
 isassign: boolean;
 selectedAssignModels: ResourceMappingModel[] = [];
 selectedUnassignModels: ResourceMappingModel[] = [];
 filename: string = '';
 resource: ResourceModel;
 assignedmodelresources: ResourceMappingModel[] = [];
 unassignedmodelresources: ResourceMappingModel[] = [];
 isProcessingFile = true;
 isLoadingMapping = false;
 @ViewChild("assignedmodelsdataGrid") assignedmodelsdataGrid: DxDataGridComponent;
 @ViewChild("unassignedmodelsdataGrid") unassignedmodelsdataGrid: DxDataGridComponent;
 @ViewChild('openmodal') openmodal:ElementRef;
 @ViewChild('closemodal') closemodal:ElementRef;



  constructor(private service: ProductCategoryService, private hostElement: ElementRef, private fb: FormBuilder, private cdRef:ChangeDetectorRef) {
    setTimeout(()=>{
      if (!window.location.href.includes("access_token")) {
        if (!this.isUserAuthenticated) {
          force.createOauthCallbackURL("resource-mapping");
          let params: any[] = [];
          params.push(this.getParameterByName("resourceId", window.location.href));
          force.login(JSON.stringify(params));
        }
      }
    },3000);

  }

  ngOnInit() {
    force.reloadAccess();
    let state = JSON.parse(force.decodeStateParams());
    this.identifier = state[0];
    this.isUserAuthenticated = true; // force.isAuthenticated();
    this.isCorrectRole = true; //- Debug  this.isRoleAcceptable();
    this.getResourcesMappings();
    this.createForm();
  }

  isRoleAcceptable() {
    force.query("select PermissionSet.Label, Assignee.Id from PermissionSetAssignment").then(result => {
        let records: any[] = (<any>result).records;
        records.forEach(r => {
          if (r.Assignee.Id == String(force.getUserId())) {
            if (r.PermissionSet.Label == "API Access") {
              this.isCorrectRole = true;
            }
          }
        })
      });
  }

  getParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
  }

  createForm() {
    this.form = this.fb.group({
      publishon: ['', Validators.required],
      unpublishon: [null]
    });

  }

  openpublishmodal() {
    this.openmodal.nativeElement.click();
  }

  // @HostListener("document:click")
  // handleClick() {
  //     this.showRowActions = false;
  // }

  toggleRowAssignActions(e: Event) {
    e.stopPropagation();
    e.preventDefault();

    this.showRowAssignActions = !this.showRowAssignActions;
  }

  toggleRowUnassignActions(e: Event) {
    e.stopPropagation();
    e.preventDefault();

    this.showRowUnassignActions = !this.showRowUnassignActions;
  }

  assignResources() {
    this.isassign = true;
    this.selectedAssignModels = [];
    this.selectedAssignRows.forEach(r => {
        let resourcemappings = this.unassignedmodelresources.find(u => u.id == r.id && u.productId == r.productId);
        if (resourcemappings) {
          this.selectedAssignModels.push(resourcemappings);
        }
      }
    )
    // Skipping Modal, no longer setting publish dates in UI
    //this.openpublishmodal();
    this.onSubmit();
  }

  unassignResources() {
    this.isassign = false;
    this.selectedUnassignModels = [];
    this.selectedUnassignRows.forEach(r =>
      {
        let resourcemappings = this.assignedmodelresources.find(u => u.id == r.id && u.productId == r.productId);
        if (resourcemappings) {
          this.selectedUnassignModels.push(resourcemappings);
        }
      }
    )
    //this.openpublishmodal();
    this.onSubmit();
  }

  onSubmit() {
    if (this.isassign) {
      // let publishon: string = this.momentdateadapter.format(this.form.get('publishon').value, "MM/DD/YYYY");
      // let unpublishon: string = this.form.get('unpublishon').value ? this.momentdateadapter.format(this.form.get('unpublishon').value, "MM/DD/YYYY") : null;
      // Only set date based on field in SF
      // this.selectedAssignModels.forEach(m =>
      // {
      //   m.publishon = publishon;
      //   m.unpublishon = unpublishon;
      // });
      this.service.assignModelsToResource(this.identifier, this.selectedAssignModels)
      .subscribe(
        res => {
          setTimeout(() => {
            this.getResourcesMappings();
            this.showRowAssignActions = false;
            this.selectedAssignModels = [];
            this.cdRef.detectChanges();
            this.closemodal.nativeElement.click();
            this.form.reset();
          }, 3000)
        }
      );
    } else {
      // let publishon: string = this.momentdateadapter.format(this.form.get('publishon').value, "MM/DD/YYYY");
      // let unpublishon: string = this.momentdateadapter.format(this.form.get('unpublishon').value, "MM/DD/YYYY");
      // this.selectedUnassignModels.forEach(m =>
      // {
      //   m.publishon = publishon;
      //   m.unpublishon = unpublishon;
      // });
      this.service.unassignModelsToResource(this.identifier, this.selectedUnassignModels)
      .subscribe(
        res => {
          setTimeout(() => {
            this.getResourcesMappings();
            this.showRowUnassignActions = false;
            this.selectedUnassignModels = [];
            this.cdRef.detectChanges();
            // this.closemodal.nativeElement.click();
            // this.form.reset();
          }, 3000);
        }
      );
    }
  }

  dateFilter = (d: Date): boolean => {
      const publishon = this._getPublishOnDate();
      return moment(d).isSameOrAfter(publishon);
  }

  private _getPublishOnDate() {
      return moment(this.form.get('publishon').value);
  }


  getResourcesMappings() {

    this.isProcessingFile = true;
    this.isLoadingMapping = true;
    this.service.getResource(this.identifier)
    .subscribe(
      res => {
        this.resource = res ? new ResourceModel(res) : new ResourceModel();
        this.filename = this.resource.documenturi ? this.resource.documenturi.substring(this.resource.documenturi.lastIndexOf('/')+1) : '';
        // this.identifier = this.resource.id;
        this.isProcessingFile = false;

        this.service.getAssignedModels(this.identifier)
        .subscribe(
          res => {
            var assignedModels: any[];
            assignedModels = res as any[];
            this.assignedmodelresources =  assignedModels ? assignedModels.map(item =>new ResourceMappingModel(item)) : [];
            this.isLoadingMapping = false;
          },
          err => notify("Cannot find the assigned models", "error", 3000)
        );

        this.service.getUnassignedModels(this.identifier)
        .subscribe(
          res => {
            var unassignedModels: any[];
            unassignedModels = res as any[];
            this.unassignedmodelresources =  unassignedModels ? unassignedModels.map(item =>new ResourceMappingModel(item)) : [];
          },
          err => notify("Cannot find the unassigned models", "error", 3000)
        );

      },
      err => notify("Cannot find the resource", "error", 3000)
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/resource-mapping/resource-mapping.component.ts